import { render, staticRenderFns } from "./parkCardDetail.vue?vue&type=template&id=91000604&scoped=true"
import script from "./parkCardDetail.vue?vue&type=script&lang=js"
export * from "./parkCardDetail.vue?vue&type=script&lang=js"
import style0 from "./parkCardDetail.vue?vue&type=style&index=0&id=91000604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91000604",
  null
  
)

export default component.exports